import styled, { css } from "styled-components";
import {
  COLORS,
  LAYER_COLORS,
  TEXT_COLORS,
} from "../../../constants/design/colors";
import { FONT_CSS, FONT_SIZE } from "../../../constants/design/fontSize";
import { SPACING } from "../../../constants/design/spacing";

export const InputContainer = styled.div`
  margin: ${SPACING.three}px 0;
`;

export const InputLabel = styled.span`
  ${FONT_CSS.label.three}
  color: ${TEXT_COLORS.three};
`;

export const InputError = styled.span`
  color: ${COLORS.negative.one};
  font-size: ${FONT_SIZE.two};
`;

export const InfoRow = styled.div<{ error?: boolean }>`
  ${FONT_CSS.data.four}
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.two}px;
  padding: ${SPACING.two}px 0;

  span:first-child {
    ${FONT_CSS.label.two}
    color: ${TEXT_COLORS.three};
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  span:last-child {
    flex-shrink: 0;
    white-space: nowrap;
  }

  ${({ error }) =>
    error &&
    css`
      span {
        color: ${COLORS.negative.one} !important;
      }
    `}
`;

export const HeaderText = styled.p`
  font-size: ${FONT_SIZE};
  margin-bottom: ${SPACING.two}px;
`;

export const QRSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px;
  gap: ${SPACING.two}px;
`;

export const QRWrapper = styled.div`
  padding: ${SPACING.two}px;
  background-color: ${COLORS.white.one};
  border-radius: 8px;

  svg {
    display: block;
  }
`;

export const AddressText = styled.span`
  ${FONT_CSS.data.four}
  color: ${TEXT_COLORS.two};
  font-family: monospace;
`;

export const CopyButton = styled.button`
  ${FONT_CSS.label.three}
  color: ${TEXT_COLORS.two};
  background-color: ${LAYER_COLORS.four};
  border-radius: 8px;
  padding: ${SPACING.two}px ${SPACING.three}px;

  &:hover {
    background-color: ${LAYER_COLORS.two};
  }
`;

export const SliderContainer = styled.div`
  margin-top: ${SPACING.two}px;
  margin-bottom: ${SPACING.one}px;
`;

export const SliderRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.two}px;
`;

export const PercentageLabel = styled.span`
  ${FONT_CSS.label.three}
  color: ${TEXT_COLORS.two};
  min-width: 36px;
  text-align: right;
`;

export const SliderInput = styled.input<{ percentage: number }>`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 4px;
  border-radius: 2px;
  outline: none;
  cursor: pointer;
  background: ${({ percentage }) =>
    `linear-gradient(to right, ${COLORS.highlight.one} 0%, ${COLORS.highlight.one} ${percentage}%, ${LAYER_COLORS.four} ${percentage}%, ${LAYER_COLORS.four} 100%)`};

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: ${COLORS.highlight.one};
    cursor: pointer;
    box-shadow: 0 0 4px ${COLORS.positive.two};
  }

  &::-moz-range-thumb {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: ${COLORS.positive.one};
    cursor: pointer;
    border: none;
    box-shadow: 0 0 4px ${COLORS.positive.two};
  }
`;
